export const VERSION = import.meta.env.VITE_VERSION;
export const MODE = import.meta.env.MODE;
export const CONTENT_BASE = import.meta.env.VITE_CONTENT_BASE
export const MEDIA_BASE = import.meta.env.VITE_MEDIA_BASE
export const BACKOFFICE_URL = import.meta.env.VITE_BACKOFFICE_URL
export const API_BASE = import.meta.env.VITE_API_BASE